import { DecimalPipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'percentageSymbol'
})
export class PercentageSymbolPipe implements PipeTransform {

    constructor(private decimalPipe: DecimalPipe) { }

    transform(amount: any, format?: 'number2dp'): any {
        if (amount === null || amount === undefined) {
            return amount;
        }
        if (format == 'number2dp') {
            amount = this.decimalPipe.transform(amount, '1.2-2');
        }
        return `${amount}%`;
    }

}
